/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classNames from 'classnames';
import { SlideArrow } from '@lt/components/icons-react/userflow';
import { useSwiper } from 'swiper/react';
import styles from './navigationButton.module.css';

type NavigationButtonProps = {
  direction: 'next' | 'prev';
};

const NavigationButton: React.FC<NavigationButtonProps> = ({ direction }) => {
  const swiper = useSwiper();

  const handleClick = () => {
    if (direction === 'next') {
      swiper.slideNext();
    } else {
      swiper.slidePrev();
    }
  };

  return (
    <div
      role="button"
      tabIndex={-1}
      className={classNames(styles.button, {
        [styles.buttonNext]: direction === 'next',
        [styles.buttonPrev]: direction === 'prev',
      })}
      onClick={handleClick}
    >
      <SlideArrow className={styles.arrowIcon} />
    </div>
  );
};

export default NavigationButton;
